export function getEnv(): string {
  return import.meta.env.VITE_ENV || '';
}

export function isProduction(): boolean {
  return getEnv() === 'production';
}

export function isDevelopment(): boolean {
  return getEnv() === 'development';
}

export function isLocal(): boolean {
  return getEnv() === 'local';
}
